import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../_components/common/Navbar';
import SideNavBar from '../../../_components/common/SideNavBar'
import { orgAdminAreaData } from '../OrgAdminArea/SidebarData'
import { differentTeams } from './formData';
import './index.css'
import { Input } from 'reactstrap';
import ModalComponent from '../../../_components/common/Modal';
import UtilityNav from '../../../_components/common/UtilityNav';
import TableNew from '../../../_components/common/Table';
import tableSort from '../../../_components/common/Sort';
import { orgAdminAction, alertActions } from '../../../_actions';

class OrgTeamMembers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            reset: false,
            orgId: null,
            showTable: false,
            differentTeam: false,
            makeTeamLead: false,
            teamDetails: null,
            sortType: false,
            updateModalState: false,
            updateMessage: null,
            getTeamMemberListResponseData: '',
            teamId: 'null',
            checkBoxData: [],
            buttonData: [],
            navData: [],
            tableData: [
            ]
        }
    }

    componentDidMount() {
        const { id } = this.props.match.params;

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
        this.props.dispatch(orgAdminAction.getOrgTeamHandler(id, () => {
            const query = new URLSearchParams(this.props.location.search);
            const ids = {}

            for (let param of query.entries()) {
                ids[param[0]] = param[1];
            }

            if (ids.team === undefined) {
                const queryParams = [];
                queryParams.push(encodeURIComponent('team') + '=' + encodeURIComponent(this.props.getOrgTeamsResponse[0].id))
                const queryString = queryParams.join('&');
                this.props.history.push({
                    search: '?' + queryString
                });
                this.setState({
                    showTable: true,
                    teamId: this.props.getOrgTeamsResponse[0].id,
                })
                const fd = {
                    'team_id': this.props.getOrgTeamsResponse[0].id
                }
                this.props.dispatch(orgAdminAction.getTeamMemberListHandler(fd, (data) => {
                    this.disableResetButton(data)
                }))
            }


            // ids === 
            //      this.props.history.replace(`/organisation/${this.props.match.params.id}/my-teams/virtual-teams/manage-share/245`)


            if (ids.team) {
                this.setState({
                    showTable: true,
                    teamId: +ids.team,
                })
                const fd = {
                    'team_id': +ids.team
                }
                this.props.dispatch(orgAdminAction.getTeamMemberListHandler(fd, (data) => {
                    this.disableResetButton(data)
                }))
            }
        }))

        this.setState({
            orgId: id,
            buttonData: [
                {
                    id: 1,
                    name: 'Move To A Different Team',
                    toggler: this.toggleDifferentTeamModal.bind(this),
                    togglerModal: this.state.differentTeam,
                    disabled: 'disabled',
                    title: 'Move To a Different Team'
                }, {
                    id: 2,
                    name: 'Reset Team Leader',
                    toggler: this.toggleResetModal.bind(this),
                    togglerModal: this.state.reset,
                    title: 'Reset Team Leader',

                }
            ]
        })


    }

    componentDidUpdate(prevProps, prevState) {

        if(prevProps.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }

        if (prevProps.getTeamMemberListResponse !== this.props.getTeamMemberListResponse) {
            if (this.props.getTeamMemberListResponse !== '') {

                // const getReformatData = this.getReformatData(this.props.getTeamMemberListResponse)
                const returnData = [];
                for (let i = 0; i < this.props.getTeamMemberListResponse.length; i++) {
                    returnData.push({
                        ...this.props.getTeamMemberListResponse[i],
                        'rowCheck': true
                    })
                }
                this.setState({
                    getTeamMemberListResponseData: returnData
                })
            }
        }
    }

    compareBy(key) {
        return tableSort(key, this.state.sortType)
    }

    sortBy(columnKey, type) {
        this.setState({ sortType: type })
        let arrayCopy = this.getReformatData(this.props.getTeamMemberListResponse)
        arrayCopy.sort(this.compareBy(columnKey));
        this.setState({ getTeamMemberListResponseData: arrayCopy });
    }

    toggleDifferentTeamModal(showModal) {
        this.setState({
            differentTeam: true
        })
    }
    toggleResetModal(showModal) {
        this.setState({
            reset: true
        })
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    actionSelected(data) {
        const memberId = [];
        for (let i = 0; i < this.state.checkBoxData.length; i++) {
            memberId.push(this.state.checkBoxData[i].user_id)
        }
        const fd = {
            "team_id": data.data.team_id,
            "user_id": memberId,
            "analytics_org_id": +this.props.match.params.id
        }
        this.props.dispatch(orgAdminAction.moveToDifferentTeamHandler(fd, this.state.teamId, (data) => {
            this.setState({
                updateMessage: {
                    status: data.status,
                    text: `<div className = " text-center">
                    <p className = "font-weight-bold">${(data.status === 200 || data.status === 201) ? 'Success!' : 'Error!'}</p>
                    <p> ${data.data.message}.</p>
                </div>`,
                    heading: 'Move To A Different Team',
                    headerColor: (data.status === 200 || data.status === 201) ? `` : `bg-danger`,
                    headingIcon: (data.status === 200 || data.status === 201) ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                },
                updateModalState: true
            })
        }))
    }

    toggleEntireMemberLevelModal(showModal) {
        this.setState({
            differentTeam: showModal,
            reset: showModal,
            makeTeamLead: showModal
        })
    }

    toggleMakeTeamLeadModal = (showModal) => {

        this.setState({
            reset: false,
            differentTeam: false,
            teamDetails: showModal,
            makeTeamLead: true,
            // teamId: ''
        })
    }
    onClickMakeTeamLead = (type) => {

        if (type === 'Submit') {
            const fd = {
                'user_id': this.state.teamDetails.user_id,
                'analytics_organisation': +this.props.match.params.id
            }
            this.props.dispatch(orgAdminAction.makeTeamLeaderHandler(fd, this.state.teamId, (data) => {
                const fd1 = {
                    'team_id': +this.state.teamId
                }
                this.props.dispatch(orgAdminAction.getTeamMemberListHandler(fd1, (data) => {
                    this.disableResetButton(data)
                }))
                this.setState({
                    updateMessage: {
                        status: data.status,
                        text: `<div className = " text-center">
                        <p className = "font-weight-bold">${(data.status === 200 || data.status === 201) ? 'Success!' : 'Error!'}</p>
                        <p> ${data.data.message}.</p>
                    </div>`,
                        heading: 'Make Team Leader',
                        headerColor: (data.status === 200 || data.status === 201) ? `` : `bg-danger`,
                        headingIcon: (data.status === 200 || data.status === 201) ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                    },
                    updateModalState: true
                })


            }))
        }
        this.setState({
            makeTeamLead: false,
        })
    }

    onClickResetTeamLead = (type) => {
        if (type === 'Submit') {
            const fd = {
                'team_id': this.state.teamId
            }
            this.props.dispatch(orgAdminAction.resetTeamLeaderHandler(fd, this.state.teamId, () => {
                const fd1 = {
                    'team_id': +this.state.teamId
                }
                this.props.dispatch(orgAdminAction.getTeamMemberListHandler(fd1, (data) => {
                    this.disableResetButton(data)
                }))
            }))
        }
        this.setState({
            reset: false,
        })
    }

    disableResetButton = (data) => {
        if (data.data.team_members.length === 0) {
            const buttonData = []
            for (let i = 0; i < this.state.buttonData.length; i++) {
                if (this.state.buttonData[i].id === 2) {
                    buttonData.push({
                        ...this.state.buttonData[i],
                        'disabled': 'disabled'
                    })
                }
                else {
                    buttonData.push({
                        ...this.state.buttonData[i]
                    })
                }
            }
            this.setState({
                buttonData: buttonData
            })
        }
        else {
            const buttonData = []
            for (let i = 0; i < this.state.buttonData.length; i++) {
                if (this.state.buttonData[i].id === 2) {
                    buttonData.push({
                        ...this.state.buttonData[i],
                        'disabled': ''
                    })
                }
                else {
                    buttonData.push({
                        ...this.state.buttonData[i]
                    })
                }
            }
            this.setState({
                buttonData: buttonData
            })
        }
    }

    onChangeTeam = (ev) => {
        const eventValue = ev.target.value
        if (ev.target.value !== "null") {
            this.setState({
                showTable: true,
                teamId: eventValue
            }, () => {
                const queryParams = [];
                queryParams.push(encodeURIComponent('team') + '=' + encodeURIComponent(eventValue))
                const queryString = queryParams.join('&');
                this.props.history.push({
                    search: '?' + queryString
                });
            })
            const fd = {
                'team_id': +ev.target.value
            }
            this.props.dispatch(orgAdminAction.getTeamMemberListHandler(fd, (data) => {
                this.disableResetButton(data)
            }))
        }
        if (ev.target.value === "null") {
            this.props.history.push({
                search: ''
            });
            this.setState({
                showTable: false,
                teamId: 'null'
            });
        }
    }

    getSelectedData(data) {

        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, false)
            })
        }
    }

    selectAllAssessment(data, clickToggle) {
        const { buttonData } = this.state;
        clickToggle === true ?
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = ''
                    this.setState({
                        reRenderSettingsHead: 2,
                        assessmentResponse: data
                    })
                }
            })
            :
            buttonData.map((val, i) => {
                if (val.disabled !== undefined && i == 0) {
                    val.disabled = 'disabled'
                    this.setState({
                        reRenderSettingsHead: 1,
                        assessmentResponse: data
                    })
                }
            })
    }

    getTeamData(teamData) {
        const data = <div className="">
            <p className=" text-center">The following members will be moved to the new team -</p>
            <div className="mx-5 mb-4 text-center ">
                {
                    teamData.map(
                        (data, i) => {
                            return <span key={i}>{data.user__full_name} {teamData.length === i + 1 ? '' : ', '}</span>
                        }
                    )

                }
            </div>
        </div>
        return data
    }

    getChildrenData = (childrenData, tempData) => {
        for (let j = 0; j < childrenData.length; j++) {
            if (childrenData[j] !== null && childrenData[j].children.length > 0) {
                tempData.push({
                    ...childrenData[j],
                    'buttonDisabled': childrenData[j].is_parent
                })
                this.getChildrenData(childrenData[j].children, tempData)
            }
            if (childrenData[j] !== null && childrenData[j].children.length == 0) {
                tempData.push({
                    ...childrenData[j],
                    'buttonDisabled': childrenData[j].is_parent
                })
            }
        }
    }

    getReformatOrgTeams = (tableData) => {
        let tempData = [];
        for (let i = 0; i < tableData.length; i++) {
            if (tableData[i].children.length > 0) {
                tempData.push({
                    ...tableData[i],
                    'buttonDisabled': tableData[i].is_parent
                })
                this.getChildrenData(tableData[i].children, tempData)
            }
            if (tableData[i].children.length === 0) {
                tempData.push({
                    ...tableData[i],
                    'buttonDisabled': tableData[i].is_parent
                })
            }
        }
        return tempData
    }

    getReformatData = (responseData) => {
        const returnData = [];
        for (let i = 0; i < responseData.length; i++) {
            returnData.push({
                ...responseData[i],
                'rowCheck': true
            })
        }
        return returnData
    }

    render() {
        const { getOrgTeamsResponse, getTeamMemberListResponse } = this.props;

        const tables = {
            Team: [{
                name: 'Name',
                key: 'user__full_name',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                rowCheck: 'rowCheck'
            },
            {
                name: 'Email',
                key: 'user__email',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: ''
            },
            {
                name: 'Level',
                key: 'user__user_level',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: ''
            },
            {
                name: '',
                key: 'EDIT',
                link: '',
                sort: false,
                type: 'Button',
                content: 'Make Team Leader',
                alignCenter: false,
                buttonDisabled: 'is_team_leader',
                link: '',
                title: "Make Team Leader"
            },]
        }

        this.state.differentTeam === true &&
            differentTeams.map(
                (data, i) => {
                    if (data.key === 'team_id') {
                        data.value = '',
                            data.elementConfig.options = this.getReformatOrgTeams(this.props.getOrgTeamsResponse);
                    }
                }
            )
        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={orgAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">MANAGE TEAM MEMBERS</h5>
                        <div className="d-flex flex-row justify-content-center">
                            <span className="col- my-1 mb-0 " > Team: &nbsp;
                                	{/* {
                                    loading &&
                                    <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                } */}
                            </span>
                            <Input
                                value={this.state.teamId}
                                type="select" name="field"
                                bsSize="sm" className="col-2 border-1 mb-2"
                                onChange={this.onChangeTeam}
                            >
                                <option className="" value='null' key={0}>select Team</option>
                                {
                                    getOrgTeamsResponse !== '' &&
                                    this.getReformatOrgTeams(getOrgTeamsResponse).map(
                                        (data, i) => {
                                            return <option className="" value={data.id} key={i}>{data.team_name}</option>
                                        }
                                    )
                                }
                            </Input>
                        </div>
                        {
                            this.state.showTable === true &&
                            <UtilityNav
                                actionButtons={this.state.buttonData}
                                modal={this.toggleModal.bind(this)}
                                showModal={this.state.modal}
                            />
                        }

                        {
                            (getTeamMemberListResponse !== '' && this.state.showTable === true) &&
                            <TableNew
                                data={this.state.getTeamMemberListResponseData === '' ? this.getReformatData(getTeamMemberListResponse) : this.state.getTeamMemberListResponseData}
                                columns={tables.Team}
                                onClickEditButton={this.toggleMakeTeamLeadModal.bind(this)}
                                checkbox="true"
                                selectCheckBox={this.selectAllAssessment.bind(this)}
                                getData={this.getSelectedData.bind(this)}
                                CheckKey={"user_id"}
                                sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                                sortType={this.state.sortType}
                            />
                        }
                        {
                            this.state.showTable === false &&
                            <h6 className="text-center mt-5">No Data to display, Please Select Any Team from the dropdown</h6>
                        }

                        {
                            (getTeamMemberListResponse === '' && this.state.showTable === true) &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                &nbsp;Loading</p>
                        }

                        {
                            this.state.differentTeam &&
                            <ModalComponent
                                showModal={this.state.differentTeam}
                                heading="Move To A Different Team"
                                formData={differentTeams}
                                action={this.actionSelected.bind(this)}
                                htmlTag={this.getTeamData(this.state.checkBoxData)}
                                toggleEntireModal={this.toggleEntireMemberLevelModal.bind(this)}
                                footerFormSubmitButton={['Move', 'Cancel']}
                                selectKey={['id']}
                                selects={['team_name']}
                            />
                        }

                        {
                            this.state.reset &&
                            <ModalComponent
                                showModal={this.state.reset}
                                heading="Make Team Leader"
                                htmlText={`<div className = "ml-1 ml-md-3 pl-1 pl-md-3 text-center">
                                <p className="">Are you sure you want to reset the team lead?</p>`}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Submit',
                                }, {
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onClickResetTeamLead(type)}
                            />
                        }

                        {
                            this.state.makeTeamLead &&
                            <ModalComponent
                                showModal={this.state.makeTeamLead}
                                heading="Make Team Leader"
                                htmlText={`<div className = " ml-1 ml-md-3 pl-1 pl-md-3 text-center">
                                <p>Are you sure you want to make <b>"${this.state.teamDetails.user__full_name} (${this.state.teamDetails.user__email})"</b> as team lead?</p>`}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Submit',
                                }, {
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onClickMakeTeamLead(type)}
                                toggleEntireModal={this.toggleEntireMemberLevelModal.bind(this)}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }

                    </div>
                </ div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { getOrgTeamsLoading } = state.getOrgTeams;
    const getOrgTeamsError = state.getOrgTeams.error;
    const getOrgTeamsResponse = (!getOrgTeamsLoading && !getOrgTeamsError) ? state.getOrgTeams.data.data.team_list : '';

    const { getTeamMemberListLoading } = state.getTeamMemberListReducer;
    const getTeamMemberListError = state.getTeamMemberListReducer.error;
    const getTeamMemberListResponse = (!getTeamMemberListLoading && !getTeamMemberListError) ? state.getTeamMemberListReducer.data.data.team_members : '';

    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';
    return {
        getOrgTeamsLoading,
        getOrgTeamsResponse,
        getTeamMemberListResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(OrgTeamMembers);


// WEBPACK FOOTER //
// ./src/_pages/Organzation/OrgAdminArea/OurTeamMembers.js